import { Button } from "antd";
import { useTopic } from "./hooks/use-topics";

interface IDocumentsListButtonProps {
  showHeader?: boolean;
}

export const DocumentsListButton = ({
  showHeader = true
}: IDocumentsListButtonProps) => {
  const { setDocListModalVisible } = useTopic();
  return (
    <Button
      style={
        showHeader
          ? {}
          : {
              marginLeft: "auto",
              marginBottom: "10px"
            }
      }
      onClick={() => {
        setDocListModalVisible(true);
      }}
    >
      Documents list
    </Button>
  );
};
